import { OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { AirportService } from '../../airport/airport.service';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { UserService } from '../../shared/user/user.service';
import { ProcDownloadComponent } from '../proc-download/proc-download.component';
var FavoritesListComponent = /** @class */ (function () {
    function FavoritesListComponent(_airports, _userService, _dialog) {
        this._airports = _airports;
        this._userService = _userService;
        this._dialog = _dialog;
        this.userInfo = null;
    }
    FavoritesListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._userService.userInfo.pipe(first(function (v) { return v !== null; })).subscribe(function (e) { return _this._onUserInfoUpdate(e); });
    };
    FavoritesListComponent.prototype._onUserInfoUpdate = function (e) {
        this.userInfo = e;
        var idList = $.map(this.userInfo.favoriteAirports, function (a) {
            return a.identifier;
        }).join();
        if (this.userInfo.homeAirportIdent) {
            idList += ',' + this.userInfo.homeAirportIdent;
        }
        if (idList) {
            this.favoritesPromise = new StatefulPromise(this._airports.getFavoriteAirports(idList));
        }
        else {
            this.favoritesPromise = null;
        }
    };
    Object.defineProperty(FavoritesListComponent.prototype, "_favorites", {
        get: function () {
            if (!this.favoritesPromise || this.favoritesPromise.state !== PromiseState.Fulfilled) {
                return null;
            }
            return this.favoritesPromise.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FavoritesListComponent.prototype, "favorites", {
        get: function () {
            return this._favorites;
        },
        enumerable: true,
        configurable: true
    });
    FavoritesListComponent.prototype.downloadProcs = function () {
        this._dialog.open(ProcDownloadComponent, {
            width: '600px',
            height: '740px',
            panelClass: 'proc-download-dialog',
            data: {
                airports: this._favorites
            }
        });
    };
    return FavoritesListComponent;
}());
export { FavoritesListComponent };
